import Spinner from 'common/components/Spinner'
import {FC, useEffect, useState} from 'react'

// update modal title here
const title = 'Student Manager Help'

const Loading = () => {
  return (
    <div className='w-100 h-100 d-flex justify-content-center align-items-center flex-column'>
      <Spinner type='grow' size='lg' color='primary' />
    </div>
  )
}

const VideoFrame: FC<{src: string}> = ({src}) => {
  const [loading, setLoading] = useState(true)
  return (
    <>
      {loading && <Loading />}
      <iframe
        src={src}
        width='100%'
        height='480'
        allow='autoplay'
        title={title ?? 'help iframe'}
        onLoad={() => setLoading(false)}
        className={loading ? 'd-none' : 'd-block'}
      ></iframe>
    </>
  )
}

const Parent: FC<{setTitle: (title: string) => void}> = ({setTitle}) => {
  useEffect(() => {
    if (title && setTitle) setTitle(title)
  }, [setTitle])

  return (
    <>
      {/* html starts here */}
      <h3>Add New Parent</h3>
      <VideoFrame src='https://drive.google.com/file/d/1hABRe62t-49HkujiXpXv6Ngs1YHZS8ok/preview' />

      <h3 className='mt-5'>Sibling Report</h3>
      <VideoFrame src='https://drive.google.com/file/d/1Glu2_G32DBm398XasJibYEAlpEEzJ6ot/preview' />

      <h3 className='mt-5'>Parent Log In Info</h3>
      <VideoFrame src='https://drive.google.com/file/d/1gIR65LwGixVWUoRcEPBm1LPC8Ax9K7kg/preview' />

      <h3 className='mt-5'>preView & Edit Parent Profile</h3>
      <VideoFrame src='https://drive.google.com/file/d/1Qei7PXSak6X3Rr1g8JkLqh83Bs6gwnjJ/preview' />

      <h3 className='mt-5'>Delete Parent (In-Activate)</h3>
      <VideoFrame src='https://drive.google.com/file/d/1EMpNdC9RSn9Lq6x_9cgV08SjPDUtze5K/preview' />

      {/* html ends here */}
    </>
  )
}

export default Parent
